import { useState } from "react";

export default function useCheckedWithFade(fadeTimeout = 2500) {
  const [checked, _setChecked] = useState(false);

  return {
    checked,
    setChecked: () => {
      _setChecked(true);

      setTimeout(() => _setChecked(false), fadeTimeout);
    }
  };
}
